import { securedAxiosInstance } from "../axios";

class OrdersService {
  create(storeId, orderParams) {
    return securedAxiosInstance.post(`/api/v1/store/${storeId}/orders`, orderParams);
  }
}

export default new OrdersService();
